import LegalLayout from "./LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout title="Política de Cookies">
      <p>Esta web utiliza cookies para garantizar su correcto funcionamiento y mejorar la experiencia de usuario. A continuación explicamos qué son y cómo las utilizamos.</p>

      <h2>1. ¿Qué es una cookie?</h2>
      <p>Una cookie es un pequeño archivo que se descarga en tu dispositivo al visitar un sitio web. Sirve para recordar tus preferencias o realizar mediciones.</p>

      <h2>2. Cookies que utilizamos</h2>
      <ul>
        <li><strong>Técnicas (necesarias):</strong> permiten la navegación básica, el mantenimiento de sesión del panel de administración y el funcionamiento del pago con Stripe. No requieren consentimiento.</li>
        <li><strong>De pago (Stripe):</strong> establecidas por Stripe durante el proceso de reserva del depósito. Consulta la política de Stripe: <a className="underline" href="https://stripe.com/es/privacy" target="_blank" rel="noopener noreferrer">stripe.com/es/privacy</a>.</li>
        <li><strong>Analíticas:</strong> actualmente <strong>no utilizamos</strong> cookies analíticas o publicitarias.</li>
      </ul>

      <h2>3. Cómo desactivar las cookies</h2>
      <p>Puedes bloquear o eliminar las cookies desde la configuración de tu navegador:</p>
      <ul>
        <li>Chrome: Configuración → Privacidad y seguridad → Cookies</li>
        <li>Firefox: Preferencias → Privacidad y seguridad</li>
        <li>Safari: Preferencias → Privacidad</li>
      </ul>

      <h2>4. Actualizaciones</h2>
      <p>Podemos actualizar esta política. La versión vigente estará siempre disponible en esta página.</p>

      <p className="text-xs opacity-70 mt-8">Última actualización: julio de 2026.</p>
    </LegalLayout>
  );
}
